import { render, staticRenderFns } from "./AlertDetails.vue?vue&type=template&id=ce342bf2&scoped=true&"
import script from "./AlertDetails.vue?vue&type=script&lang=js&"
export * from "./AlertDetails.vue?vue&type=script&lang=js&"
import style0 from "./AlertDetails.vue?vue&type=style&index=0&id=ce342bf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce342bf2",
  null
  
)

export default component.exports